module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page', [_c('template', {
    slot: "title"
  }, [_vm._v("Вакансии")]), _vm._v(" "), _c('template', {
    slot: "section"
  }, [_c('columns', [_c('column', {
    attrs: {
      "size": "10"
    }
  }, [_c('p', [_vm._v("Наша компания заинтересована в притоке высококвалифицированных специалистов. Развитие кадрового потенциалы является одной из приоритетных задач нашей компании. Со своей стороны мы предлагаем:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("высокий уровень заработной платы (обсуждаем по результатам собеседования).")]), _vm._v(" "), _c('li', [_vm._v("­оформление по ТК РФ, график работы: свободный, ненормируемый (возможна удаленная работа).")]), _vm._v(" "), _c('li', [_vm._v("­широкие перспективы профессиональной самореализации.")]), _vm._v(" "), _c('li', [_vm._v("­открытость к Вашим идеям по развитию и поддержку в их реализации.")])])])], 1), _vm._v(" "), _c('columns', [_c('column', {
    attrs: {
      "size": "10"
    }
  }, [_c('heading', [_vm._v("Открытые вакансии:")]), _vm._v(" "), _c('ul', _vm._l((_vm.allVacancies), function(vacancy, index) {
    return _c('li', {
      key: index
    }, [_c('vacancy', {
      attrs: {
        "vacancy": vacancy
      }
    })], 1)
  }))], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "aside"
  }, [_c('aside-image', {
    attrs: {
      "image": _vm.imageBg
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b7ebb148"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Vacancies.vue
// module id = 138
// module chunks = 0